import React from 'react';

import { ClickAwayListener, IconButton } from '@material-ui/core';
import { MenuItem, Select } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import cx from 'classnames';
import moment from 'moment';

import { ReactComponent as FilterIcon } from 'pages/Teachers/ClassroomInsights/assets/filter-icon.svg';
import { ReactComponent as SearchIcon } from 'pages/Teachers/Home/assets/search-icon.svg';

import styles from './styles.module.scss';

const NavSearchAndFilter = ({
  query,
  onChange,
  filtersOpen,
  setFiltersOpen,
  open,
  handleScroll,
  assignments,
  handleSelect,
  openSection,
  setOpenSection,
  sectionValue,
  setSectionValue,
  setPagination,
  userSections,
  classes,
  getRenderedSectionName
}) => {
  return (
    <ClickAwayListener onClickAway={() => setFiltersOpen(false)}>
      <div className={styles.searchWrapper}>
        <div className={styles.searchInput}>
          <IconButton
            className={styles.filterBtn}
            onClick={() => setFiltersOpen((prev) => !prev)}
          >
            <FilterIcon />
          </IconButton>

          <input
            type="text"
            placeholder="Search Assignments, Standards, or Sections here..."
            value={query}
            onChange={onChange}
          />

          <SearchIcon className={styles.searchIcon} />
        </div>

        {open && (
          <div className={styles.results} onScroll={handleScroll}>
            {assignments.length === 0 && (
              <div className={cx(styles.result, styles.empty)}>
                No assignments found
              </div>
            )}
            {assignments.map((assignment, index) => (
              <div
                key={index}
                className={styles.result}
                onClick={() => handleSelect({ assignment })}
              >
                <Tooltip title={assignment.name}>
                  <div className={styles.nameSection}>{assignment.name}</div>
                </Tooltip>
                <Tooltip title={assignment.section_name}>
                  <div className={styles.sectionBox}>
                    {assignment.section_name}
                  </div>
                </Tooltip>
                <div className={styles.dueDate}>
                  {moment(assignment.due_date).format('MMM D, YYYY')}
                </div>
              </div>
            ))}
          </div>
        )}

        {filtersOpen && (
          <div className={styles.filters}>
            <Select
              open={openSection}
              onClose={() => setOpenSection(false)}
              onOpen={() => setOpenSection(true)}
              value={sectionValue}
              onChange={(level) => {
                setSectionValue(level.target.value);
                setFiltersOpen(false);
                setPagination({ offset: 0, limit: 20 });
              }}
              renderValue={(selected) =>
                getRenderedSectionName({
                  selected: selected,
                  userSections: userSections
                })
              }
              IconComponent={ExpandMoreIcon}
              className={classes.selectRoot}
              classes={{
                select: classes.inputText,
                icon: classes.selectIcon
              }}
              MenuProps={{ disablePortal: true }}
            >
              <MenuItem value="placeholder">Assignment Section</MenuItem>
              {userSections.map(({ id, name }) => (
                <MenuItem key={id} value={id} className={classes.menuItem}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
};

export default NavSearchAndFilter;
